export function StaticPage({ title, children }: { title: string; children: React.ReactNode }) {
  return <div className="static-page section-shell"><h1>{title}</h1><div className="static-copy">{children}</div></div>
}
